import Url from "nexia_mobile/url";

export default {
  parseLinksNext(links) {
    const link = _.first(links);
    if (link) {
      this._nextHref = link.href;
      if (this.clonedResource) {
        this.clonedResource._nextHref = link.href;
      }
    } else {
      this._nextHref = null;
      if (this.clonedResource) {
        this.clonedResource._nextHref = null;
      }
    }
  },

  hasNextPage() {
    return Boolean(this._nextHref);
  },

  fetchNextPage(options) {
    return this._getPageFromHref(this._nextHref, options);
  },

  parseLinksPrevious(links) {
    const link = _.first(links);
    if (link) {
      this._previousHref = link.href;
      if (this.clonedResource) {
        this.clonedResource._previousHref = link.href;
      }
    } else {
      this._previousHref = null;
      if (this.clonedResource) {
        this.clonedResource._previousHref = null;
      }
    }
  },

  hasPreviousPage() {
    return Boolean(this._previousHref);
  },

  fetchPreviousPage(options) {
    return this._getPageFromHref(this._previousHref, options);
  },

  parseLinksPage(links) {
    const link = _.first(links);
    if (link) {
      this._pageTemplateLink = link.href;
      const data = link.getData();
      this._pageCount = data.page_count;
      this._currentPageNumber = data.current_page;
      if (this.clonedResource) {
        this.clonedResource._pageTemplateLink = link.href;
        this.clonedResource._pageCount = data.page_count;
        this.clonedResource._currentPageNumber = data.current_page;
      }
    } else {
      this._pageTemplateLink = null;
      this._pageCount = null;
      this._currentPageNumber = null;
      if (this.clonedResource) {
        this.clonedResource._pageTemplateLink = null;
        this.clonedResource._pageCount = null;
        this.clonedResource._currentPageNumber = null;
      }
    }
  },

  getPages() {
    let pages = [];
    for (let pageNumber = 1; pageNumber <= this._pageCount; pageNumber++) {
      pages.push({ pageNumber });
    }
    return pages;
  },

  currentPageNumber() {
    return this._currentPageNumber || 1;
  },

  fetchCurrentPage() {
    const href = Url.expandTemplate(this._pageTemplateLink, {
      page: this.currentPageNumber(),
    });
    return this._getPageFromHref(href);
  },

  fetchPage(pageNumber) {
    if (!this._pageCount) {
      throw new Error(
        "Attempted to fetch a page before a Page link was parsed"
      );
    }
    if (pageNumber > this._pageCount) {
      throw new Error(
        `Attempted to get page with pageNumber ${pageNumber} which was higher than the pageCount ${this._pageCount}`
      );
    }
    const href = Url.expandTemplate(this._pageTemplateLink, {
      page: pageNumber,
    });
    return this._getPageFromHref(href);
  },

  _getPageFromHref(href, options) {
    if (href == null) {
      throw new Error("Attempted to get page from null href");
    }
    return this.fetchUrlWithResourceClone(href, options).then((newPage) => {
      this.reset(newPage.models);
    });
  },
};



// WEBPACK FOOTER //
// ./src/models/mixins/pageable.js